import './index.styl';
import template from './index.jst';
import { View } from 'backbone.marionette';
import Radio from "backbone.radio";
import _ from 'lodash';

const playerComparisonChannel = Radio.channel('player:comparison');

export class PlayerComparisonBoard extends View {
	get template() {
		return template;
	}

	initialize() {
		this.listenTo(playerComparisonChannel, 'player:add', this.addPlayer);
		this.listenTo(playerComparisonChannel, 'add:favourite:player', this.onAddFavourite);
		this.listenTo(playerComparisonChannel, 'remove:favourite:player', this.onRemoveFavourite);
		this.listenTo(playerComparisonChannel, 'switch:to:multi:tab', this.switchToMulti);
		this.listenTo(playerComparisonChannel, 'switch:to:h2h:tab', this.switchToh2h);
		this.listenTo(playerComparisonChannel, 'removed:player', this.onPlayerRemove);
		this.listenTo(this.model, 'change', this.notifyAboutBoardSize);
		this.listenTo(this.model, 'change', this.render);
	}

	switchToMulti() {
		this.model.switchToMulti();
	}

	switchToh2h() {
		const removed_players = this.model.switchToh2h();
		playerComparisonChannel.trigger('removed:player', { player: removed_players });
		this.notifyAboutBoardSize();
	}

	onAddFavourite({ player_id }) {
		this.model
			.markAsFavourite(player_id)
			.trigger('change');
	}

	onRemoveFavourite({ player_id }) {
		this.model
			.unMarkAsFavourite(player_id)
			.trigger('change');
	}

	get is_board_full() {
		const
			compare = this.model.get('compare'),
			max_board_size = this.model.get('max_players_size');

		return _.size(compare) >= max_board_size;
	}

	notifyAboutBoardSize() {
		const event_type = this.is_board_full ? 'lock' : 'unlock';
		playerComparisonChannel.trigger(`${event_type}:players`);

		return this;
	}

	addPlayer({ player }) {
		if (this.is_board_full) {
			return this;
		}

		this.model.get('compare').push(player);
		this.model.trigger('change');
	}

	onPlayerRemove({ player }) {
		if (_.isPlainObject(player)) {
			this.model
				.removePlayer({ player_id: player.id })
				.trigger('change');
		}

		return this;
	}
}

export default PlayerComparisonBoard;